export default __webpack_public_path__ + "static/SR France - Fiche de Données Sécurité - Caramel colorant (Liquide)-4c3656d2fb231a4d9c7eb9555b846542.pdf";